export function UnifiedLoadingShell({ title, subtitle, children }) {
  return (
    <main className="chamii-viewport chamii-safe-top chamii-safe-bottom chamii-auth-shell bg-dots flex items-center justify-center p-6">
      <section className="w-full max-w-md rounded-[2rem] border-2 border-brand-textDark/10 bg-brand-yellow px-8 py-10 text-center">
        <img
          src="/chamii-logo-icon-only.png"
          alt="Chamii"
          className="mx-auto h-14 w-14 object-contain"
        />
        <h1 className="mt-6 text-2xl font-black text-brand-textDark">{title}</h1>
        {subtitle ? <p className="mt-2 font-bold text-brand-text">{subtitle}</p> : null}
        {children ? <div className="mt-7 grid gap-3">{children}</div> : null}
      </section>
    </main>
  )
}
